// Only used per 17/01/2025 to load changelog on member profile page

;(function () {
  window.initLazyComponentLoad = function (scope) {
    var doInsert, doReplace
    doInsert = function (insertTarget) {
      return function (rawData) {
        initSUI(insertTarget.parent())
        initPage(insertTarget.parent())
        insertTarget.trigger("lazy-loaded")
        return console.log("Component lazy loaded")
      }
    }
    doReplace = function (insertTarget) {
      return function (rawData) {
        var data, parent
        data = $(rawData)
        parent = insertTarget.parent()
        insertTarget.replaceWith(data)
        initSUI(data)
        initPage(data)
        parent.trigger("lazy-loaded")
        return console.log("Component lazy loaded and initial element replaced")
      }
    }
    $("a[data-load-replace], form[data-load-replace]").each(function () {
      var handler, replaceTargetId
      replaceTargetId = "#" + $(this).attr("data-load-replace")
      handler = function (event) {
        var data, replaceTarget, status, xhr
        data = event.detail[0].getElementsByTagName("body")[0].innerHTML
        status = event.detail[1]
        xhr = event.detail[2]
        if ($(replaceTargetId)[0]) {
          replaceTarget = $(replaceTargetId)
        }
        return doReplace(replaceTarget)(data)
      }
      $(this).on("ajax:success", handler)
      $(this).on("ajax:error", handler)
      return $(this).removeAttr("data-load-replace")
    })
    return $("[data-load]").each(function (_, elem) {
      var el, insertTarget, loadFnc, replace, targetId, trigger, url
      el = $(elem)
      insertTarget = el
      targetId = el.attr("data-load-target")
      if (targetId) {
        insertTarget = $("#" + targetId)
      }
      url = el.attr("data-load")
      trigger = el.attr("data-load-trigger")
      replace = el.attr("data-load-replace") !== void 0
      loadFnc = replace
        ? function () {
            insertTarget
              .addClass("loading")
              .html('<div class="ui loader"></div>')
            return $.get(url, doReplace(insertTarget))
          }
        : function () {
            insertTarget
              .addClass("loading")
              .html('<div class="ui loader"></div>')
            return insertTarget.load(url, doInsert(insertTarget))
          }
      if (targetId) {
        $(el).click(loadFnc)
      } else if (trigger) {
        $("#" + trigger).click(loadFnc)
      } else {
        loadFnc()
      }
      el.removeAttr("data-load")
      el.removeAttr("data-load-target")
      el.removeAttr("data-load-trigger")
      return el.removeAttr("data-load-replace")
    })
  }
}).call(this)
